/*
 * COPYRIGHT © 2026 SANITÀNEXUS WHITE-LABEL. ALL RIGHTS RESERVED.
 * AUTHOR AND SOLE DEVELOPER: MARCO PANZETTI (C.F. PNZMRC89M14F251C)
 * Protected under Italian Copyright Law (Legge 633/1941) and International Treaties.
 */

const ROUTE_BY_TARGET = {
  post: (id) => `/posts/${id}`,
  conversation: (id) => `/chat/${id}`,
  initiative: () => '/bacheca',
  portal_report: (id) => (id ? `/portale?report=${id}` : '/portale'),
};

/** Deep-link for a notification, or null when the target type has no page. */
export const notificationRoute = (n) => {
  const build = ROUTE_BY_TARGET[n?.target_type];
  return build ? build(n.target_id) : null;
};
